import * as MdIcons from 'react-icons/md'
import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { useFindTaskComments } from '@hooks/comments'
import { useFindTask } from '@hooks/task/find'

import {
  CommentsButton,
  ViewCommentsContainer,
  ViewCommentsLink,
} from './styles'

interface IViewCommentsProps {
  handlePress: () => void
}

export function ViewComments({ handlePress }: IViewCommentsProps) {
  const theme = useTheme()
  const { taskId } = useParams<{ taskId: string }>()

  const { data: rawTask } = useFindTask(Number(taskId))

  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const { data: rawComments } = useFindTaskComments(Number(taskId))

  const comments = rawComments ?? []
  const commentsNumber = comments.length

  return (
    <CommentsButton onClick={() => !task.sapActionsType && handlePress()}>
      <ViewCommentsContainer>
        <MdIcons.MdChatBubbleOutline
          size={24}
          color={theme.colors.textLink}
        />

        <ViewCommentsLink>
          View {commentsNumber} comments / Add Comments
        </ViewCommentsLink>
      </ViewCommentsContainer>
    </CommentsButton>
  )
}
